import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { checkAddPermission, checkDeletePermission, checkEditPermission, fetchBrandFilterV2, fetchCategoryDataFilterV2, fetchOriginDataFilterV2, handleExportFile, handleImportClickFile, handleUpdateAllCheckbox, handleUpdateDataCheckbox, setupEditFormData, TableFooter } from "../../../Utils/helper";
import Import from "../../../Utils/import";
import { getApi } from "../../../Services/apiService";
import DeleteModal from "../../../Utils/deleteModal";
import EditProductGroup from "./editProductGroup";
import { toast } from "react-toastify";
import { clearIdsStatus } from "../../../Counter/createGroup";
import { DependentMultiSelectDropdown } from "../../../Utils/multiSelectDropdown";
function ProductGroup() {
  const dispatch = useDispatch();
  const groupData = useSelector(state => state.createGroup.data);
  
  const [methodType, setMethodType] = useState(groupData?.method || "");
  
  const { data } = useSelector((state) => state.roleData);
  const [showImportModal, setShowImportModal] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [importErrors, setImportErrors] = useState({
    file: '',
    general: ''
  });
  const [searchQuery, setSearchQuery] = useState('')
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [productGroup, setProductGroup] = useState({})
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  const [productGroupToEdit, setProductGroupToEdit] = useState(null);
  const [mainProductGrouping, setMainProductGrouping] = useState(0);
  const [formData, setFormData] = useState({
    category: '',
    code: '',
    coo: '',
    group_id: '',
    group_no: '',
    id: '',
    name_en: '',
    name_tc: '',
    net_weight: '',
    specification: '',
    variety: '',
    is_active: true  // Default to active when creating new buyer
  });
  const [formDataCopy, setFormDataCopy] = useState({
    category: '',
    code: '',
    coo: '',
    group_id: '',
    group_no: '',
    id: '',
    name_en: '',
    name_tc: '',
    net_weight: '',
    specification: '',
    variety: '',
    is_active: true  // Default to active when creating new buyer
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [pageCount, setPageCount] = useState(null)
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([])
  const [selectedOriginIds, setSelectedOriginIds] = useState([])
  const [selectedBrandName, setSelectedBrandName] = useState([])

  const [showAddProductModal, setShowAddProductModal] = useState(false);
  const [selectedShowProducts, setSelectedShowProducts] = useState(groupData?.idsStatus ||[]);
  const [productSearchQuery, setProductSearchQuery] = useState('');
  const [availableProducts, setAvailableProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [productlist, setProductList] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [filteredProducts, setFilteredProducts] = useState([]);
  const handleProductClick = (product) => {
    setSelectedProducts(prev => {
      const isAlreadySelected = prev.some(p => p.id === product.id);
      if (isAlreadySelected) {
        return prev.filter(p => p.id !== product.id);
      } else {
        return [...prev, {
          ...product,
          quantity: null,
          barCode: null,
          is_main_product:0
        }];
        // return [...prev, product];
      }
    });
    setSearchTerm('');
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredProducts([]);
      setIsDropdownOpen(false);
      return;
    }
    handleSearchProduct()
    
  }, [searchTerm]);

  const handleSearchProduct = async()=>{
    const response = await getApi(`/product?per_page=20&page=1&search=${searchTerm}`)
      if (response?.success) {
       
    
  
    const filtered = response.data.products?.data.filter(product => {
      if (!product?.code && !product?.name_en && !product?.name_tc) return false;
      
      const searchTermLower = searchTerm.toLowerCase().trim();
      if (!searchTermLower) return true;    
      const searchableFields = [
        product.code?.toString().toLowerCase() || '',
        product.name_en?.toLowerCase() || '',
        product.name_tc?.toLowerCase() || ''
      ];    
      const searchWords = searchTermLower.split(/\s+/).filter(Boolean);    
      const codeMatches = product.code?.toString().toLowerCase() === searchTermLower;    
      const nameMatches = searchWords.every(searchWord => 
        searchableFields.some(field => 
          field.includes(searchWord)
        )
      );
    
      return codeMatches || nameMatches;
    });
    setFilteredProducts(filtered);
    setIsDropdownOpen(filtered.length > 0);
  }
  }

  const toggleAllProductsCheckbox = (isChecked) => {
    setSelectedProducts(isChecked
      ? productlist.map(product => ({
        ...product,
        quantity: null,
        barCode: null,
        checked: true
      }))
      : []);
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      if (showAddProductModal && methodType!='edit' && methodType!='add') {
        fetchAvailableProducts();
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [productSearchQuery, showAddProductModal]);

  useEffect(()=>{
    getProdcutData()
  },[])
  const getProdcutData = async () => {
    const response = await getApi('/product?per_page=999')
    if (response?.success) {
      setProductList(response.data.products?.data || []);
    }
  }

  
  const fetchAvailableProducts = async () => {
    try {
      const response = await getApi(`/product?search=${encodeURIComponent(productSearchQuery)}&per_page=999`);
      if (response?.success) {
        setAvailableProducts(response.data.products.data || []);
        // setProductList(response.data.products.data || []);
      } else {
        toast.error(response?.msg || 'Failed to fetch products');
      }
    } catch (error) {
      toast.error(error.message || 'Failed to fetch products');
    }
  };

  const handleProductChange = (id, field, value) => {
    setSelectedShowProducts(prev => prev.map(product =>
      product.id === id ? { ...product, [field]: value } : product
    ));
  };

  const removeProduct = (idToRemove) => {
    // setProducts(prev => prev.filter(product => product.id !== id));
    setSelectedProducts(prevItems => prevItems.filter(item => item.id !== idToRemove));
  };
  const removeProducts = (idToRemove) => {
    // setProducts(prev => prev.filter(product => product.id !== id));
    setSelectedShowProducts(prevItems => prevItems.filter(item => item.id !== idToRemove));
  };


  // const pageCount = productGroup?.last_page || 1;
  const handlePageClick = (selected) => {
    setCurrentPage(selected);
  };

  const fetchProductGroup = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const queryParams = new URLSearchParams();
      if (Array.isArray(selectedCategoryIds)) {
        selectedCategoryIds.forEach((id) => queryParams.append('category_ids[]', id));
      } else if (selectedCategoryIds) {
        queryParams.append('category_ids[]', selectedCategoryIds);
      }
      if (Array.isArray(selectedBrandName)) {
        selectedBrandName.forEach((id) => queryParams.append('brands[]', id));
      } else if (selectedBrandName) {
        queryParams.append('brands[]', selectedBrandName);
      }
      if (Array.isArray(selectedOriginIds)) {
        selectedOriginIds.forEach((id) => queryParams.append('origin_ids[]', id));
      } else if (selectedOriginIds) {
        queryParams.append('origin_ids[]', selectedOriginIds);
      }
      queryParams.append('search', searchQuery);
      queryParams.append('page', currentPage);
      queryParams.append('per_page', itemsPerPage);
      queryParams.append('is_main_product', mainProductGrouping);

      const response = await getApi(`/product-group?${queryParams.toString()}`);

      if (response?.success) {
        setProductGroup(response.data.productGroups?.data || []);
        setPageCount(response.data.productGroups?.last_page || 1)
      } else {
        setError(response?.msg || 'Failed to fetch buyers');
      }
    } catch (error) {
      setError(error.message || 'Failed to fetch buyers');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if(methodType!=='edit' && methodType!=='add'){
      fetchProductGroup();
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQuery, currentPage, itemsPerPage,methodType, mainProductGrouping, selectedCategoryIds, selectedBrandName, selectedOriginIds]);
  // useEffect(()=>{
  //   fetchProductGroup()
  // },[currentPage,itemsPerPage])

  const handleSetMainProduct = (selectedProduct) => {
    const updatedProducts = selectedShowProducts.map(product => ({
      ...product,
      is_main_product: product.id === selectedProduct.id ? 1 : 0
    }));
      setSelectedShowProducts(updatedProducts);
  };
  

  return (
    <div className="RightSideDiv product-grouping arive product-single">

{showAddProductModal && (
        <div className="modal-overlay arive-add-product">
          <div className="modal-content">
            <div className="modal-header">
              <h3>Add Product</h3>
              <img
                src={window.getPublicUrl('/assets/images/close.svg')}
                onClick={() => { setShowAddProductModal(false); setSelectedProducts([]); setSearchTerm('') }}
                className="close"
                alt="Close"
              />
            </div>
            <div className="modal-body p-0">
              <div className="form-group">
                <label>Search Product</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by product code or name"
                  // value={productSearchQuery}
                  // onChange={(e) => setProductSearchQuery(e.target.value)}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onFocus={() => searchTerm.trim() !== '' && setIsDropdownOpen(true)}
                />
              </div>
              <div className="product-list">

                <table className="custom-table table-striped product-bottom-cs">
                  <thead>
                    <tr>
                      <th className="checkbox">
                        <label className="checbox-cs">
                          <input
                            type="checkbox"
                            onChange={(e) => toggleAllProductsCheckbox(e.target.checked)}
                            // checked={productlist.length > 0 && productlist.every(p => p.checked)}
                            checked={productlist.length > 0 && selectedProducts.length === productlist.length}
                            indeterminate={
                              selectedProducts.length > 0 &&
                              selectedProducts.length < productlist.length
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                      </th>
                      <th className="product-code">Product Code</th>
                      <th className="product-name">Product Name (EN)</th>
                      <th className="product-name">Product Name (TC)</th>
                      <th className="specification">Specification</th>
                      <th className="specification">Net Weight</th>
                      {/* <th className="quantity">Quantity</th>
                      <th className="barcode">Barcode</th> */}
                      {/* <th className="action">Action</th> */}
                    </tr>
                  </thead>

                  <tbody>
                    {(filteredProducts||productlist) && (searchTerm!='' ? filteredProducts : productlist).map((product, index) => (
                      // index<10 &&
                      <tr key={product.id}>
                        <td className="checkbox">
                          <label className="checbox-cs">
                            <input
                              type="checkbox"
                              checked={selectedProducts.some(p => p.id === product.id)}
                              onClick={() => handleProductClick(product)}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </td>
                        <td className="product-code">{product.code}</td>
                        <td className="product-name">{product.name_en}</td>
                        <td className="product-name">{product.name_tc}</td>
                        <td className="specification">{product.specification}</td>
                        <td className="specification">{product.net_weight}</td>
                        {/* <td className="quantity">
                          <input
                            type="text"
                            className='input-enter'
                            placeholder="10"
                            value={product.quantity}
                            onChange={(e) => handleProductChange(product.id, 'quantity', e.target.value)}
                          />
                        </td>
                        <td className="barcode">
                          <input
                            type="text"
                            className='input-enter'
                            placeholder="10"
                            value={product.barcode}
                            onChange={(e) => handleProductChange(product.id, 'barcode', e.target.value)}
                          />
                        </td> */}
                        {/* <td className="action">
                          <div className="">
                            <button
                              className="cross-btn"
                              onClick={() => removeProduct(product.id)}
                            >
                              <img src={window.getPublicUrl('/assets/images/white-cross.png')} alt="" />
                            </button>
                          </div>
                        </td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button className="reset" onClick={() => { setSelectedProducts([]); setShowAddProductModal(false); setSearchTerm('') }}>
                Cancel
              </button>
              <button
                className="save mt-0"
                onClick={() => {
                  if (selectedProducts.length === 0) {
                    toast.error('Please select at least one product');
                    return;
                  }
                  setSelectedShowProducts(selectedProducts)
                  setSelectedProducts([]);
                  setShowAddProductModal(false);
                  setSearchTerm('')
                }}
                disabled={selectedProducts.length === 0}
              >
                Add Selected Products ({selectedProducts.length})
              </button>
            </div>
          </div>
        </div>
      )}

      {showImportModal && <Import setImportFile={setImportFile} importFile={importFile} searchQuery={searchQuery} fetchData={fetchProductGroup} setShowImportModal={setShowImportModal} routeEnd={'/product-group/import'} routeexport={'/product-group/export'} type={'Product-Group'} />
      }

      {showDeleteModal && (
        <DeleteModal setShowDeleteModal={setShowDeleteModal} todelete={productToDelete} isLoading={isLoading} setIsLoading={setIsLoading} settoDelete={setProductToDelete} fetchData={fetchProductGroup} route={`/product-group/${productToDelete?.id}`} type={'product group'} />
      )}

      {methodType === "" && (
        <div class="row">
          <div class="col-sm-12">
            <div className="setting-right setting-right-table table-border-show product-grouping arrival">
              <div class="table-header">
                <div className="header-left">
                  <div className="search-card">
                    <img
                      src={window.getPublicUrl(
                        "/assets/images/search-icon.svg"
                      )}
                      alt=""
                    />
                    <input
                      type="text"
                      class="search-input"
                      placeholder="Search Product Group..."
                      value={searchQuery}
                      onChange={(e) => {setSearchQuery(e.target.value);setCurrentPage(1)}}
                    />
                  </div>

                  <button class={`btn ${mainProductGrouping===1?"checked":""}`} onClick={() => { setMainProductGrouping(mainProductGrouping === 0 ? 1 : 0); setCurrentPage(1) }}>
                    <img src="" alt="" />
                    Main Product Grouping{" "}
                  </button>
                   
                  <DependentMultiSelectDropdown
                    selectedValues={selectedCategoryIds}
                    setSelectedValues={setSelectedCategoryIds}
                    placeholder='Select Categories...'
                    noOptionsMessage='No categories available'
                    setCurrentPage={setCurrentPage}
                    fetchOptionsApi={fetchCategoryDataFilterV2}
                    dependentFilters={{
                      search_product_name_code: searchQuery, //only for product name and code, if need to support product group name and code then need to change in apis
                      origin_ids: selectedOriginIds,
                      brands: selectedBrandName,
                    }}
                  />


                  <DependentMultiSelectDropdown
                    selectedValues={selectedOriginIds}
                    setSelectedValues={setSelectedOriginIds}
                    placeholder="Select origin..."
                    noOptionsMessage='No origin available'
                    setCurrentPage={setCurrentPage}
                    fetchOptionsApi={fetchOriginDataFilterV2}
                    dependentFilters={{
                      search_product_name_code: searchQuery,
                      category_ids: selectedCategoryIds,
                      brands: selectedBrandName,
                    }}
                  />

                  <DependentMultiSelectDropdown
                    selectedValues={selectedBrandName}
                    setSelectedValues={setSelectedBrandName}
                    placeholder="Select brand..."
                    noOptionsMessage='No Brand available'
                    setCurrentPage={setCurrentPage}
                    fetchOptionsApi={fetchBrandFilterV2}
                    dependentFilters={{
                      search_product_name_code: searchQuery,
                      category_ids: selectedCategoryIds,
                      origin_ids: selectedOriginIds,
                    }}
                  />
                </div>
                <div class="table-actions">
                {checkAddPermission(data?.permissions, 'product_grouping') && (
                  <button class="btn" onClick={() => handleImportClickFile(setShowImportModal, setImportFile, setImportErrors)}>
                    <img
                      src={window.getPublicUrl("/assets/images/import.png")}
                      alt=""
                    />
                    Import
                  </button>
                )}
                  <button class="btn" onClick={() => handleExportFile(productGroup, searchQuery, 'productGroup.xlsx', '/product-group/export')}>
                    <img
                      src={window.getPublicUrl("/assets/images/export.svg")}
                      alt=""
                    />
                    Export
                  </button>
                  {/* <button class="btn">
                    <img
                      src={window.getPublicUrl(
                        "/assets/images/create-group.svg"
                      )}
                      alt=""
                    />
                    Create Group
                  </button> */}

                  {checkAddPermission(data?.permissions, 'product_grouping') && (
                    <button class="btn add" onClick={() => {
                      setMethodType("add");
                      setSelectedShowProducts([]);
                      dispatch(clearIdsStatus());
                    }}>
                      + Add New Product Group
                    </button>
                  )}

                </div>
              </div>



              <div className="permission-table-inner">
                <table class="custom-table table-striped ">
                  <thead>
                    <tr>
                      <th class="checkbox">
                        <label class="checbox-cs">
                          <input type="checkbox" onClick={(e) => handleUpdateAllCheckbox(e?.target?.checked, setProductGroup)} />
                          <span class="checkmark"></span>
                        </label>
                      </th>
                      <th class="gr-no">Gr No</th>
                      <th class="gr-name">Gr Name</th>
                      <th class="code">Code</th>
                      <th class="name-en">Name(EN)</th>
                      <th class="name-tc">Name(TC)</th>
                      <th class="category">Category</th>
                      <th class="coo">Coo</th>
                      <th class="varierty">Varierty</th>
                      <th class="net-wt">Net Wt.</th>
                      <th class="specification">Specification</th>
                      <th class="action">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <tr>
                        <td colSpan="10" className="text-center">
                          <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </td>
                      </tr>
                    ) : error ? (
                      <tr>
                        <td colSpan="6" className="text-center text-danger">{error}</td>
                      </tr>
                    ) : productGroup?.length === 0 ? (
                      <tr>
                        <td colSpan="10" className="text-center">No Product Group found</td>
                      </tr>
                    ) : (
                      productGroup?.length > 0 && productGroup?.map((product, index) => (
                        <tr className={product?.is_main_product === 1 ? "main-product-row" : ""}>
                          <td class="checkbox">
                            <label class="checbox-cs">
                              <input type="checkbox" onClick={(e) => handleUpdateDataCheckbox(product, e, setProductGroup)} checked={product?.status} />
                              <span class="checkmark"></span>
                            </label>
                          </td>
                          <td class="gr-no">{product?.group_no}</td>
                          <td class="gr-name">{product?.name}</td>
                          <td class="code">{product?.code}</td>
                          <td class="name-en">{product?.name_en}</td>
                          <td class="name-tc">{product?.name_tc}</td>
                          <td class="category">{product?.category}</td>
                          <td class="coo">{product?.coo}</td>
                          <td class="varierty">{product?.variety}</td>
                          <td class="net-wt">{product?.net_weight}</td>
                          <td class="specification">{product?.specification}</td>
                          <td class="action action-cs">
                            <div class="dropdown">
                                {(checkEditPermission(data?.permissions, 'product_grouping') || checkDeletePermission(data?.permissions, 'product_grouping')) && (
                            <button class=" dropdown-toggle action-btn" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"> <img src={window.getPublicUrl('/assets/images/dots-icon.svg')} alt="" /></button>
                                )}
                            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                              <li>
                              {checkEditPermission(data?.permissions, 'product_grouping') && (
                                  
                                    <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); setupEditFormData(product, setFormData, setMethodType, setProductGroupToEdit, formDataCopy);dispatch(clearIdsStatus()); }}>
                                      Edit
                                  
                                  </a>
                                )}
                              </li>
                              <li>
                              {checkDeletePermission(data?.permissions, 'product_grouping') && (
                                  <a href="#" className="dropdown-item" onClick={(e) => { e.preventDefault(); setProductToDelete(product); setShowDeleteModal(true); }}>Delete</a>
                                )}
                              </li>
                              </ul>
                               
                               
                            </div>
                          </td>
                        </tr>
                      )))}
                  </tbody>
                </table>
                {/* <div class="table-footer">
                  <select name="" id="" className='affter-change-cs page'>
                    <option value="">20</option>
                    <option value="">15</option>
                    <option value="">10</option>
                    <option value="">5</option>
                  </select>
                </div> */}
  
              </div>
              <div class="table-footer d-flex justify-content-between table-pagination">
                  <select name="" id="" className='affter-change-cs page' value={itemsPerPage} onChange={(e) => {setItemsPerPage(Number(e.target.value)); setCurrentPage(1) }}>
                  <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="250">250</option>
                    <option value="500">500</option>
                  </select>
                  <div className=''>
                    <TableFooter
                      pageCount={pageCount}
                      handlePageClick={handlePageClick}
                      currentPage={currentPage}
                    />
                  </div>
                </div>
            </div>
          </div>
        </div>
      )}
      {methodType === "add" && (
        // <div class="row">
        //   <div class="col-sm-12">
        //     <div class="setting-right position-relative  add-new-product-group">
        //       <h3>Add New Product Group</h3>
        //       <img
        //         src={window.getPublicUrl("/assets/images/close.svg")}
        //         alt="Close" className="close"
        //       />

        //       <div className="setting-right setting-right-table table-border-show product-grouping mx-3 mt-3 mb-4 add-arrival">
        //         <div className="table-header">
        //           <div className="d-flex gap-4">
        //             <div className="search-card">
        //               <img
        //                 src={window.getPublicUrl(
        //                   "/assets/images/search-icon.svg"
        //                 )}
        //                 alt=""
        //               />
        //               <input
        //                 type="text"
        //                 className="search-input"
        //                 placeholder="Search Product"
        //               />
        //             </div>
        //             <a
        //               href=""
        //               className="add-product  d-flex align-items-center"
        //             >
        //               Add Product
        //             </a>
        //           </div>

        //         </div>
        //         <div class="row">
        //                      <div class="col-sm-3 mx-3">
        //                          <div class="form-group">
        //                              <label for="productCode">Text-filed</label>
        //                              <input type="number" id="" class="form-control" placeholder="Enter group no."  />
        //                          </div>
        //                      </div>
        //                      </div>
        //         <div className="permission-table-inner">

        //           <div class="table-outer">
        //             <div class="table-inner">
        //               <ul>
        //                 <li>1</li>
        //                 <li>NZ AMBROSIA APPLE</li>
        //                 <li>蘋果</li>
        //                 <li>10.8 KG</li>
        //                 <li>900 G / 12 PACK</li>
        //               </ul>
        //               <div class="">
        //                 {" "}
        //                 <a href="" class="cross-btn">
        //                   <img
        //                     src={window.getPublicUrl(
        //                       "/assets/images/white-cross.png"
        //                     )}
        //                     alt=""
        //                   />
        //                 </a>
        //               </div>
        //             </div>
        //             <div class="table-inner">
        //               <ul>
        //                 <li>1</li>
        //                 <li>NZ AMBROSIA APPLE</li>
        //                 <li>蘋果</li>
        //                 <li>10.8 KG</li>
        //                 <li>900 G / 12 PACK</li>
        //               </ul>
        //               <div class="">
        //                 {" "}
        //                 <a href="" class="cross-btn">
        //                   <img
        //                     src={window.getPublicUrl(
        //                       "/assets/images/white-cross.png"
        //                     )}
        //                     alt=""
        //                   />
        //                 </a>
        //               </div>
        //             </div>
        //             <div class="table-inner">
        //               <ul>
        //                 <li>1</li>
        //                 <li>NZ AMBROSIA APPLE</li>
        //                 <li>蘋果</li>
        //                 <li>10.8 KG</li>
        //                 <li>900 G / 12 PACK</li>
        //               </ul>
        //               <div class="">
        //                 {" "}
        //                 <a href="" class="cross-btn">
        //                   <img
        //                     src={window.getPublicUrl(
        //                       "/assets/images/white-cross.png"
        //                     )}
        //                     alt=""
        //                   />
        //                 </a>
        //               </div>
        //             </div>
        //           </div>
        //         </div>
        //       </div>

        //       <div class="button-settings">
        //         <div class="col-sm-12">
        //           <div class="d-flex justify-content-end gap-3">
        //             <button class="reset">Reset</button>
        //             <button class="save" onClick={() => setMethodType("")}>
        //               Save
        //             </button>
        //           </div>
        //         </div>
        //       </div>
        //     </div>
        //   </div>
        // </div>
        <EditProductGroup setMethodType={setMethodType} setFormData={setFormData} setError={setError} productToEdit={productGroupToEdit} formDataCopy={{}} type={'add'} fetchData={fetchProductGroup} setIsLoading={setIsLoading} setShowAddProductModal={setShowAddProductModal} setProductSearchQuery={setProductSearchQuery} setAvailableProducts={setAvailableProducts} fetchAvailableProducts={fetchAvailableProducts} selectedShowProducts={selectedShowProducts} removeProducts={removeProducts} setSelectedProducts={setSelectedProducts} selectedProducts={selectedProducts} handleSetMainProduct={handleSetMainProduct} setSelectedShowProducts={setSelectedShowProducts} isLoading={isLoading}/>

      )}
      {methodType === "edit" && (
        <EditProductGroup setMethodType={setMethodType} setFormData={setFormData} setError={setError} productToEdit={productGroupToEdit} formDataCopy={{}} type={'edit'} fetchData={fetchProductGroup} setIsLoading={setIsLoading} setShowAddProductModal={setShowAddProductModal} setProductSearchQuery={setProductSearchQuery} setAvailableProducts={setAvailableProducts} fetchAvailableProducts={fetchAvailableProducts} selectedShowProducts={selectedShowProducts} removeProducts={removeProducts} setSelectedProducts={setSelectedProducts} selectedProducts={selectedProducts} handleSetMainProduct={handleSetMainProduct} setSelectedShowProducts={setSelectedShowProducts} isLoading={isLoading}/>
      )}
    </div>
  );
}

export default ProductGroup;
